import http from '@/utils/http'
// 
/**
 *  @parms resquest 请求地址 例如：http://197.82.15.15:8088/request/...
 *  @param '/testIp'代表vue-cil中config，index.js中配置的代理
 */

// 类型列表
export function gettypeList(params){
    return http.get('/businessType/businessType/allList')
}
// 学校列表
export function schoolList(params){
    return http.get('/school/school/listAll')
}
// 优课展评分类列表
export function ykzptype(params){
    return http.get('/system/dict/data/type/ykzp_type')
}
// 年级列表
export function getclazzList(params){
    return http.get('/businessType/clazzType/getListByTypeId',params)
}
// 学科列表
export function getsubjectList(params){
    return http.get('/businessType/subjectType/getListByTypeId',params)
}
export function getsubjectAll(params){
    return http.get('/businessType/subjectType/listAll')
}

// 视频列表
export function getvideoList(params){
    return http.get('/videoBusiness/videoExpandadmin/getVideoSearchList',params)
}
export function getvideonewList(params){
    return http.get('/videoBusiness/videoExpandadmin/list',params)
}
// 试卷列表
export function getTestList(params){
    return http.get('/testPaperBusiness/testPaperExpand/portalList',params)
}

// 查看视频时增加次数
export function addVideoNum(id){
    return http.get('/video/videoInfo/addWatchCount/'+id)
}
// 查看试卷时增加次数
export function addTestNum(id){
    return http.get('/testPaper/paper/addWatchCount/'+id)
}

// 视频详情
export function getDetail(id){
    return http.get('/videoBusiness/videoExpandadmin/getPortalInfo/'+id)
}

// 视频详情
export function getDetail1(id,videoChildId){
    return http.get('/videoBusiness/videoExpandadmin/getPortalInfo1/'+id+'/'+videoChildId)
}
// 试卷详情
export function getTestDetail(id){
    return http.get('/testPaperBusiness/testPaperExpand/portal/'+id)
}

// 视频是否点赞/取消
export function getLike(params){
    return http.get('/video/likeRecords/getVideoLikeCount', params)
}
// 视频点赞/取消
export function setLike(data){
    return http.post('/video/likeRecords/portalVideoLike', data)
}
// 视频评论点赞/取消
export function setAssessLike(data){
    return http.post('video/commentsLikeRecords/portalCommentsLike', data)
}

// 视频是否收藏/取消
export function getCollect(params){
    return http.get('/video/favoritesRecords/getVideoFavoritesCount', params)
}
// 视频收藏/取消
export function setCollect(data){
    return http.post('/video/favoritesRecords/portalVideoFavorites', data)
}

// 大家在看列表
export function getWatchUser(params){
    return http.get('/video/watchHistory/userWatch', params)
}

// 视频详情评论列表
export function getComment(params){
    return http.get('/videoBusiness/businessCommentsExpand/portalList', params)
}
// 视频详情评论列表不登录首页
export function getCommentnoLogin(params){
    return http.get('/videoBusiness/businessCommentsExpand/index/portalList', params)
}
// 视频详情提交评论
export function setComment(data){
    return http.post('/videoBusiness/businessCommentsExpand/portalAdd', data)
}

// 视频详情的进度条
export function getVideoProgress(videoId, userId){
    return http.get('/video/watchHistory/getProgress/'+ videoId +'/'+ userId)
}
// 视频详情视频播放记录
export function getVideoWatch(videoId, userId){
    return http.get('/video/watchHistory/'+ videoId +'/'+ userId)
}
// 视频详情视频播放完之后
export function setVideoEnd(data){
    return http.post('/video/watchHistory/overWatchAdd', data)
}
// 视频详情视频播放中断
export function setVideoPause(data){
    return http.post('/video/watchHistory/portalAdd', data)
}
// 专题讲座tab
export function getsecialtab(params){
    return http.get('/system/dict/data/list', params)
}
// 融合教研tab
export function getqyjytab(params){
    return http.get('/system/dict/data/list', params)
}
// 融合教研活动list
export function getqyjyList(params){
    return http.get('/activity/info/find/video/activity', params)
}
// 融合教研视频list
export function getqyjyvideoList(params){
    return http.get('/videoBusiness/videoExpandadmin/getVideoTypeList',params)
}
// 融合教研活动详情图片list
export function getqyjyimgList(params){
    return http.get('/file/manage/list', params)
}
// 融合教研活动详情文件list
export function getqyjyfileList(params){
    return http.get('/file/manage/find/file/list', params)
}

// 资源中心tab
export function getzyzxtab(params){
    return http.get('/resourcepackage/category/noPageList', params)
}
// 资源中心list
export function getzyzxList(params){
    return http.get('/resourcepackage/package/list', params)
}
// 资源中心视频list
export function getzyzxvideoList(params){
    return http.get('/resourcepackage/package/resources/'+params.packageId+'/video',params)
}
// 资源中心详情图片list
export function getzyzximgList(params){
    return http.get('/resourcepackage/package/resources/'+params.packageId+'/image', params)
}
// 资源中心详情文件list
export function getzyzxfileList(params){
    return http.get('/resourcepackage/package/resources/'+params.packageId+'/file', params)
}
// 资源包授权检查
export function checkPackageAuth(params){
    return http.get('/resourcepackage/package/auth/check', params)
}

// 首页视频轮播
export function getvideochild(params){
    return http.get('/video/videoInfo/findVideoChildByActivityId', params)
}
// 校长论坛图片列表
export function getxzltimglist(params){
    return http.get('/file/manage/list', params)
}
// 校长论坛文件列表
export function getxzltfilelist(params){
    return http.get('/file/manage/find/file/list', params)
}
// 修改2+2 学习笔记
export function editcommtents(data){
    return http.post('/videoBusiness/businessCommentsExpand/portalEdit',data)
}
// 视频新增评论
export function addcomment(data){
    return http.post('/comment/info/webAdd',data)
}
// 视频评论列表
export function getcommentlist(params){
    return http.get('/comment/info//webList', params)
}
// 视频回复评论
export function repliescomment(data){
    return http.post('/comment/info/replyComment',data)
}
// 视频删除评论
export function deletecomment(id){
    return http.post('/comment/info/deleteComment/'+id)
}


// WEBPACK FOOTER //
// ./src/api/video.js